<div class="row d-flex justify-content-center">
    <div class="col-10 col-sm-8 col-md-6 bg-white border py-2 px-4 px-sm-6 px-md-10">
        <img class="img-fluid my-5" [src]="project.img" alt="" />
        <p class="mb-5 lh-29 text-sm-center text-start" [innerHTML]="project.html"></p>
        <div class="text-center">
            <img class="img-fluid bottomImg" [src]="project.imgBottom" alt="" />
        </div>
    </div>
</div>
